/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Receivelist_Freegames2Inputs */

const id_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengumuman game gratis baru`)
};

const ms_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengumuman permainan percuma baharu`)
};

const da_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nye gratis spil-annonceringer`)
};

const de_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ankündigungen neuer kostenloser Spiele`)
};

const en_us2_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New free game announcements`)
};

const es_es2_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuncios de nuevos juegos gratis`)
};

const es_mx2_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuncios de nuevos juegos gratis`)
};

const fil_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga anunsyo ng bagong libreng laro`)
};

const fr_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annonces de nouveaux jeux gratuits`)
};

const it_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annunci di nuovi giochi gratuiti`)
};

const hu_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Új ingyenes játék bejelentések`)
};

const nl_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aankondigingen van nieuwe gratis games`)
};

const no_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunngjøringer om nye gratis spill`)
};

const pl_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogłoszenia o nowych darmowych grach`)
};

const pt_br2_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novos anúncios de jogos gratuitos`)
};

const pt_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anúncios de novos jogos grátis`)
};

const ro_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anunțuri noi despre jocuri gratuite`)
};

const fi_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoitukset uusista ilmaispeleistä`)
};

const sv_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meddelanden om nya gratis spel`)
};

const vi_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông báo game miễn phí mới`)
};

const tr_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni ücretsiz oyun duyuruları`)
};

const cs_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oznámení o nových hrách zdarma`)
};

const bg_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обяви за нови безплатни игри`)
};

const ru_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анонсы новых бесплатных игр`)
};

const uk_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анонси нових безкоштовних ігор`)
};

const ar_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعلانات الألعاب المجانية الجديدة`)
};

const hi_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नए मुफ़्त गेम की घोषणाएँ`)
};

const th_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การประกาศเกมฟรีใหม่`)
};

const ja_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい無料ゲームのお知らせ`)
};

const zh_cn2_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新免费游戏公告`)
};

const zh_hant1_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新免費遊戲公告`)
};

const ko_notifications_receivelist_freegames2 = /** @type {(inputs: Notifications_Receivelist_Freegames2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 무료 게임 알림`)
};

/**
* | output |
* | --- |
* | "New free game announcements" |
*
* @param {Notifications_Receivelist_Freegames2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_receivelist_freegames2 = /** @type {((inputs?: Notifications_Receivelist_Freegames2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Receivelist_Freegames2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_receivelist_freegames2(inputs)
	if (locale === "ms") return ms_notifications_receivelist_freegames2(inputs)
	if (locale === "da") return da_notifications_receivelist_freegames2(inputs)
	if (locale === "de") return de_notifications_receivelist_freegames2(inputs)
	if (locale === "en-US") return en_us2_notifications_receivelist_freegames2(inputs)
	if (locale === "es-ES") return es_es2_notifications_receivelist_freegames2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_receivelist_freegames2(inputs)
	if (locale === "fil") return fil_notifications_receivelist_freegames2(inputs)
	if (locale === "fr") return fr_notifications_receivelist_freegames2(inputs)
	if (locale === "it") return it_notifications_receivelist_freegames2(inputs)
	if (locale === "hu") return hu_notifications_receivelist_freegames2(inputs)
	if (locale === "nl") return nl_notifications_receivelist_freegames2(inputs)
	if (locale === "no") return no_notifications_receivelist_freegames2(inputs)
	if (locale === "pl") return pl_notifications_receivelist_freegames2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_receivelist_freegames2(inputs)
	if (locale === "pt") return pt_notifications_receivelist_freegames2(inputs)
	if (locale === "ro") return ro_notifications_receivelist_freegames2(inputs)
	if (locale === "fi") return fi_notifications_receivelist_freegames2(inputs)
	if (locale === "sv") return sv_notifications_receivelist_freegames2(inputs)
	if (locale === "vi") return vi_notifications_receivelist_freegames2(inputs)
	if (locale === "tr") return tr_notifications_receivelist_freegames2(inputs)
	if (locale === "cs") return cs_notifications_receivelist_freegames2(inputs)
	if (locale === "bg") return bg_notifications_receivelist_freegames2(inputs)
	if (locale === "ru") return ru_notifications_receivelist_freegames2(inputs)
	if (locale === "uk") return uk_notifications_receivelist_freegames2(inputs)
	if (locale === "ar") return ar_notifications_receivelist_freegames2(inputs)
	if (locale === "hi") return hi_notifications_receivelist_freegames2(inputs)
	if (locale === "th") return th_notifications_receivelist_freegames2(inputs)
	if (locale === "ja") return ja_notifications_receivelist_freegames2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_receivelist_freegames2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_receivelist_freegames2(inputs)
	return ko_notifications_receivelist_freegames2(inputs)
});
export { notifications_receivelist_freegames2 as "notifications.receiveList.freeGames" }